const config = ()=>{
   //const apiUrl;
    const apiUrl = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_HOST
    : process.env.REACT_APP_URL_LOCAL
    return apiUrl;
};

export default config;